import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router";

import { useAuthStore } from "../store/useAuthStore";
// import LoadingSpinner from "../Components/LoadingSpinner";
import ProtectedRoute from "./ProtectedRoute";
import AdminRoutes from "./AdminRoutes";
import LoginPage from "../Components/Login";


const AppRouter = () => {

  const { checkAuth, authUser, loading } = useAuthStore()

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Protect all admin routes */}
      <Route element={<ProtectedRoute />}>
        {AdminRoutes()}
      </Route>

      {/* Catch all route (fallback) */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRouter;
